// import { useFormik } from 'formik';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import Select from 'react-select';
// import { Card, CardFooter } from '@components/card/card';
// import { CardBody, Form, Modal } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import IssueLines from './IssueLines';
// import { addIssueTransactions } from '@store/INV/Transactions/InvIssue/invIssueSlice';
// import { useNavigate } from 'react-router-dom';
// import useGetTransactionTypesIssueList from '@hooks/INV/InvIssue/useGetTransactionTypesIssueList';
// import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
// import { TreeSelect } from 'antd';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import Reference from '../Reference/Reference';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import { useEffect, useMemo, useState } from 'react';
// import { getPersonId } from '@store/Login2/authSelectors';
// import { AddIssueTransactionsSchema } from '../../../ValidationForm/validationSchema';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

// const Add = () => {
//   const [showModal, setShowModal] = useState(true);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const Navigate = useNavigate();
//   // const { dataEmployees, loading, error } = useGetPersons();
//   const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
//   const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
//   const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
//   const { treeCustomerData, loading: loading4, error: error4 } = useGetCustomersList();
//   const { treeSuppliersData, loading: loading5, error: error5 } = useGetSuppliersList();
//   const { OptionsTransactionTypes, loading: loading6, error: error6 } = useGetTransactionTypesIssueList();

//   const personId = useAppSelector(getPersonId);

//   const formik = useFormik({
//     initialValues: {
//       code: '',
//       transactionDate: new Date().toISOString().split('T')[0],
//       description: '',
//       branchId: '',
//       transactionAmount: 0,
//       referenceType: '',
//       referenceCode: '',
//       referenceId: '',
//       supplierId: null,
//       customerId: null,
//       personId: personId,
//       subInventoryId: null,
//       inventoryId: '',
//       address: '',
//       note: '',
//       transactionYear: 0,
//       materialTransactionsLineList: [
//         {
//           id: null,
//           transactionItemId: null,
//           transactionUom: '',
//           unitPrice: 0,
//           transactionQuantityIn: 0,
//           transactionQuantityOut: 0,
//           lotId: '',
//           referenceIdMaster: '',
//           referenceIdLine: ''
//         }
//       ]
//     },
//     enableReinitialize: true,
//     validationSchema: AddIssueTransactionsSchema(t),
//     onSubmit: values => {
//       dispatch(
//         addIssueTransactions({
//           code: values.code,
//           transactionDate: values.transactionDate,
//           description: values.description,
//           branchId: values.branchId,
//           transactionAmount: 0,
//           referenceType: values.code,
//           referenceId: values.referenceId || null,
//           supplierId: values.supplierId || null,
//           customerId: values.customerId || null,
//           personId: values.personId || null,
//           inventoryId: values.inventoryId,
//           address: values.address,
//           note: values.note,
//           transactionYear: 0,
//           subInventoryId: values.subInventoryId,
//           referenceCode: values.referenceCode,
//           materialTransactionsLineList: formik.values.materialTransactionsLineList?.map(item => ({
//             transactionItemId: item.transactionItemId,
//             transactionUom: item.transactionUom,
//             unitPrice: 0,
//             transactionQuantityIn: item.transactionQuantityIn,
//             transactionQuantityOut: 0,
//             lotId: item.lotId || null,
//             inventoryId: null,
//             referenceIdMaster: item.referenceIdMaster || null,
//             referenceIdLine: item.referenceIdLine || null,
//             transactionTypeId: null
//           }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             Navigate(-1 as any, { replace: true });
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   const { values, handleChange: formikhandleChange, errors, touched } = formik;

//   const isLoading = useMemo(
//     () => loading1 || loading2 || loading3 || loading4 || loading5 || loading6,
//     [loading1, loading2, loading3, loading4, loading5, loading6]
//   );

//   const isError = useMemo(
//     () => error1 || error2 || error3 || error4 || error5 || error6,
//     [error1, error2, error3, error4, error5, error6]
//   );

//   useEffect(() => {
//     if (!formik.values.branchId && OperatingUnitOptions?.length > 0) {
//       const firstOption = OperatingUnitOptions[0];
//       formik.setFieldValue('branchId', firstOption.value);
//     }
//   }, [OperatingUnitOptions]);

//   // تحديد المخزن الفرعي الأول تلقائيًا عند تغيير المخزن الرئيسي أو عند تحميل البيانات
//   useEffect(() => {
//     if (values.inventoryId && TreeSubInventoryData?.length > 0) {
//       // تصفية المخازن الفرعية التي تتبع المخزن الرئيسي المحدد
//       const filteredSubInventories = TreeSubInventoryData.filter(f => f.parentId === values.inventoryId);

//       // إذا لم يكن هناك مخزن فرعي محدد حاليًا، اختر الأول
//       if (!values.subInventoryId && filteredSubInventories.length > 0) {
//         formik.setFieldValue('subInventoryId', filteredSubInventories[0].value);
//       }
//     }
//   }, [values.inventoryId, TreeSubInventoryData, values.subInventoryId, formik]);

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: t('Home'),
//            link: ':moduleHome'
//           },
//           {
//             name: t('InvIssue'),
//             link: ''
//           },
//           {
//             name: t('AddIssueDocument'),
//             link: null
//           }
//         ]}
//         PageName={t('AddIssueDocument')}
//         subtitle={InventoryOptions?.find((f: any) => f.value === values.inventoryId)?.label}
//       />

//       <Card>
//         <Form onSubmit={formik.handleSubmit}>
//           <Loading loading={isLoading} error={isError}>
//             <CardBody>
//               <div className='row '>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Date')}</label>
//                     <Form.Control
//                       className='form-control  text-center'
//                       type='date'
//                       name='transactionDate'
//                       onChange={formikhandleChange}
//                       value={values.transactionDate || ''}
//                     />
//                     <div className='text-danger small'>
//                       {formik.touched.transactionDate && formik.errors.transactionDate}
//                     </div>
//                   </div>
//                 </div>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('OperatingUnit')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading1}
//                       isSearchable={true}
//                       isClearable
//                       options={OperatingUnitOptions}
//                       value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
//                       placeholder={t('Choose')}
//                     />
//                     <div className='text-danger small'>{formik.touched.branchId && formik.errors.branchId}</div>
//                   </div>
//                 </div>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Inventory')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading2}
//                       isSearchable={true}
//                       isClearable
//                       options={InventoryOptions}
//                       value={InventoryOptions?.find((f: any) => f.value === values.inventoryId)}
//                       placeholder={t('Choose')}
//                     />
//                     <div className='text-danger small'>{formik.touched.inventoryId && formik.errors.inventoryId}</div>
//                   </div>
//                 </div>

//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('SubInventory')}</label>
//                     <TreeSelect
//                       loading={loading3}
//                       showSearch
//                       className='w-100'
//                       treeLine
//                       placeholder={t('Choose')}
//                       allowClear
//                       treeDefaultExpandAll={false}
//                       value={values.subInventoryId}
//                       onChange={(option: any) => {
//                         formik.setFieldValue('subInventoryId', option === null ? null : option);
//                       }}
//                       treeData={TreeSubInventoryData?.filter(f => f.parentId === values.inventoryId)}
//                       treeNodeFilterProp='title'
//                     />
//                     <div className='text-danger small'>
//                       {formik.touched.subInventoryId && formik.errors.subInventoryId}
//                     </div>
//                   </div>
//                 </div>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('TransactionType')}</label>
//                     <Select
//                       isLoading={loading6}
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isSearchable={true}
//                       isClearable
//                       options={OptionsTransactionTypes}
//                       value={OptionsTransactionTypes.find(f => f.value === values.code)}
//                       onChange={(option: any) => {
//                         formik.setFieldValue('code', option === null ? null : option.value);
//                         formik.setFieldValue('materialTransactionsLineList', []);
//                       }}
//                       placeholder={t('Choose')}
//                     />
//                     <div className='text-danger small'>{formik.touched.code && formik.errors.code}</div>
//                   </div>
//                 </div>

//                 <div className='col-xl-3'>
//                   <div className='form-group mb-3'>
//                     <Reference formik={formik} />
//                     <div className='text-danger small'>{formik.touched.referenceId && formik.errors.referenceId}</div>
//                   </div>
//                 </div>

//                 {['SPR', ''].includes(values.code) && (
//                   <div className='col-lg-3'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('Supplier')}</label>
//                       <TreeSelect
//                         loading={loading5}
//                         disabled
//                         showSearch
//                         className='w-100'
//                         treeLine
//                         placeholder={t('Choose')}
//                         allowClear
//                         treeDefaultExpandAll={false}
//                         value={values.supplierId}
//                         onChange={(option: any) => {
//                           formik.setFieldValue('supplierId', option === null ? null : option);
//                         }}
//                         treeData={treeSuppliersData}
//                         treeNodeFilterProp='title'
//                       />
//                       <div className='text-danger small'>{formik.touched.supplierId && formik.errors.supplierId}</div>
//                     </div>
//                   </div>
//                 )}
//                 {['INV', 'SOI'].includes(values.code) && (
//                   <div className='col-lg-3'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('Customer')}</label>
//                       <TreeSelect
//                         disabled
//                         loading={loading4}
//                         showSearch
//                         className='w-100'
//                         treeLine
//                         allowClear
//                         treeDefaultExpandAll={false}
//                         value={values.customerId}
//                         onChange={(option: any) => {
//                           formik.setFieldValue('customerId', option === null ? null : option);
//                         }}
//                         treeData={treeCustomerData}
//                         treeNodeFilterProp='title'
//                         placeholder={t('Choose')}
//                       />
//                       <div className='text-danger small'>{formik.touched.customerId && formik.errors.customerId}</div>
//                     </div>
//                   </div>
//                 )}

//                 {/* <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('StoreKeeper')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading}
//                       isSearchable={true}
//                       isClearable
//                       name='personId'
//                       options={dataEmployees}
//                       value={dataEmployees?.find((f: any) => f.value === values.personId)}
//                       onChange={(option: any) => {
//                         formik.setFieldValue('personId', option === null ? null : option.value);
//                       }}
//                       placeholder={t('Choose')}
//                     />
//                   </div>
//                 </div> */}

//                 <div className='col-lg-6'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Note')}</label>
//                     <Form.Control
//                       autoComplete='off'
//                       className='form-control'
//                       as='textarea'
//                       rows={1}
//                       name='description'
//                       onChange={formik.handleChange}
//                       value={values.description}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </CardBody>

//             <CardFooter className='shadow-sm px-0 bg-inverse bg-opacity-10'>
//               {values.inventoryId && (
//                 <IssueLines
//                   formik={formik}
//                   handleSubmit={formik.handleSubmit} // تمرير handleSubmit
//                 />
//               )}
//             </CardFooter>

//             <div className='text-center mt-4'>
//               <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1 rounded'>
//                 {formik.isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
//                 )}
//                 {t('Add')}
//               </button>
//               <button type='button' className='btn btn-lg  me-1 btn-default mb-1 rounded' onClick={() => Navigate(-1)}>
//                 <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </Loading>
//         </Form>
//       </Card>

//       <Modal show={showModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
//         {/* العنوان */}
//         <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
//           <Modal.Title className='text-center w-100 h5'>
//             <i className='fas fa-warehouse me-2'></i>
//             {t('SelectOperatingUnitInventoryTransaction')}
//           </Modal.Title>
//         </Modal.Header>

//         {/* الجسم */}

//         <Modal.Body className='p-4'>
//           <div className='text-center mb-4'>
//             <div
//               className='bg-secondary bg-opacity-35 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
//               style={{ width: '70px', height: '70px' }}
//             >
//               <i className='fas fa-clipboard-list fs-2 text-theme'></i>
//             </div>
//             <p className='text-muted mb-0'>{t('PleaseSelectOperatingUnitInventoryTransactionType')}</p>
//           </div>

//           <div className='row'>
//             {/* وحدة التشغيل */}
//             <div className='col-12 mb-4'>
//               <label className='form-label fw-bold'>{t('OperatingUnit')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text bg-secondary bg-opacity-35  border-end-0'>
//                   <i className='fas fa-building text-theme'></i>
//                 </span>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={OperatingUnitOptions}
//                   value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
//                   onChange={(option: any) => {
//                     formik.setFieldValue('branchId', option?.value || '');
//                     formik.setFieldValue('inventoryId', '');
//                     formik.setFieldValue('code', '');
//                   }}
//                   placeholder={t('Choose')}
//                   className='flex-grow-1'
//                 />
//               </div>
//               {!formik.values.branchId && (
//                 <div className='form-text text-info mt-2'>
//                   <i className='fas fa-info-circle me-1'></i>
//                   اختر الوحدة التشغيلية أولاً لتمكين اختيار المخزن
//                 </div>
//               )}
//             </div>

//             {/* المخزن */}
//             <div className='col-12 mb-4'>
//               <label className='form-label fw-bold'>{t('Inventory')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text bg-secondary bg-opacity-35  border-end-0'>
//                   <i className='fas fa-boxes text-theme'></i>
//                 </span>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.branchId)}
//                   value={
//                     formik.values.inventoryId &&
//                     InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
//                   }
//                   onChange={option => formik.setFieldValue('inventoryId', option?.value || '')}
//                   placeholder={t('Choose')}
//                   isDisabled={!formik.values.branchId}
//                   className='flex-grow-1'
//                 />
//               </div>
//             </div>

//             {/* نوع الحركة */}
//             <div className='col-12 mb-3'>
//               <label className='form-label fw-bold'>{t('TransactionType')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text bg-secondary bg-opacity-35  border-end-0'>
//                   <i className='fas fa-exchange-alt text-theme'></i>
//                 </span>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={OptionsTransactionTypes}
//                   value={OptionsTransactionTypes?.find(f => f.value === formik.values.code)}
//                   onChange={option => formik.setFieldValue('code', option?.value || '')}
//                   placeholder={t('Choose')}
//                   isDisabled={!formik.values.inventoryId}
//                   className='flex-grow-1'
//                 />
//               </div>
//               {formik.touched.code && formik.errors.code && (
//                 <div className='text-danger small mt-2'>{formik.errors.code}</div>
//               )}
//             </div>
//           </div>
//         </Modal.Body>

//         {/* الأزرار */}
//         <Modal.Footer className='justify-content-center border-top-0 pt-0'>
//           <button
//             className='btn btn-outline-secondary btn-lg px-4 py-2 me-3'
//             onClick={() => Navigate('/INV/Transactions/InvIssue')}
//           >
//             <i className='fas fa-times me-2'></i>
//             {t('Cancel')}
//           </button>
//           <button
//             className='btn btn-theme btn-lg px-5 py-2'
//             onClick={() => setShowModal(false)}
//             disabled={!formik.values.branchId || !formik.values.inventoryId || !formik.values.code}
//           >
//             <i className='fas fa-check-circle me-2'></i>
//             {t('Continue')}
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default Add;

//  {/* <NeatixModal
//     show={showModal}
//     setShow={setShowModal}
//     size='md'
//     bodyClassName='p-0'
//     centered
//     showHeader={false}
//     keyboard={false}
//     backdrop={true}
//   >
//     <Card>
//       <CardHeader className='shadow'>
//         <div className='  text-center '>
//           <h5 className='mb-1'>{t('SelectOperatingUnitInventoryTransaction')}</h5>
//           <p className='text-muted small mb-0'>{t('PleaseSelectOperatingUnitInventoryTransactionType')}</p>
//         </div>
//       </CardHeader>
//       <Loading loading={loading1 || loading6 || loading6} error={error1 || error2 || error6} Type='Dots'>
//         <CardBody>
//           <div className='row'>
//             <div className='col-lg-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('OperatingUnit')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={OperatingUnitOptions}
//                   value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
//                   onChange={option => {
//                     formik.setFieldValue('inventoryId', '');
//                     formik.setFieldValue('branchId', option?.value || '');
//                   }}
//                   placeholder={t('Choose')}
//                 />
//               </div>
//             </div>

//             <div className='col-lg-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Inventory')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.branchId)}
//                   value={
//                     formik.values.inventoryId &&
//                     InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
//                   }
//                   onChange={option => formik.setFieldValue('inventoryId', option?.value || null)}
//                   placeholder={t('Choose')}
//                 />
//               </div>
//             </div>

//             <div className='col-lg-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('TransactionType')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isSearchable
//                   isClearable
//                   options={OptionsTransactionTypes}
//                   value={OptionsTransactionTypes?.find(f => f.value === formik.values.code)}
//                   onChange={option => formik.setFieldValue('code', option?.value || null)}
//                   placeholder={t('Choose')}
//                 />
//                 {formik.touched.code && formik.errors.code && (
//                   <div className='text-danger small'>{formik.errors.code}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </CardBody>
//       </Loading>

//       <CardFooter>
//         <div className='row'>
//           <div className='col-6'>
//             <button
//               type='button'
//               className='btn btn-lg btn-theme w-100 rounded-0'
//               onClick={() => setShowModal(false)}
//               disabled={!formik.values.branchId || !formik.values.inventoryId || !formik.values.code}
//             >
//               <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
//               {t('Select')}
//             </button>
//           </div>

//           <div className='col-6'>
//             <button
//               type='button'
//               className='btn btn-lg btn-default w-100 rounded-0'
//               onClick={() => Navigate('/INV/Transactions/InvIssue', { replace: true })}
//             >
//               <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
//             </button>
//           </div>
//         </div>
//       </CardFooter>
//     </Card>
//   </NeatixModal> */}

import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardHeader } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch } from '@store/hooks';
import IssueLines from './IssueLines';
import { addIssueTransactions } from '@store/INV/Transactions/InvIssue/invIssueSlice';
import { useNavigate } from 'react-router-dom';
import useGetTransactionTypesIssueList from '@hooks/INV/InvIssue/useGetTransactionTypesIssueList';
import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
import { TreeSelect } from 'antd';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import Loading from '@components/Shared/Loader/Loading';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import { useEffect, useMemo, useState } from 'react';
import { AddIssueTransactionsSchema } from '../../../ValidationForm/validationSchema';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import TransactionStartModal from '../TransactionStart/TransactionStartModal';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import FileUpload from '@components/Files/FileUpload';

const Add = () => {
  const [showModal, setShowModal] = useState(true);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();

  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();

  const { OperatingUnitOptions: OperatingUnitOptions2, InventoryOptions: InventoryOptions2 } = useGetOrganizations(); // وحدات التشغيل والمخازن بدون صلاحيـات

  const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
  const { treeCustomerData, loading: loading4, error: error4 } = useGetCustomersList();
  const { treeSuppliersData, loading: loading5, error: error5 } = useGetSuppliersList();
  const { OptionsTransactionTypes, loading: loading6, error: error6 } = useGetTransactionTypesIssueList();

  // const personId = useAppSelector(getPersonId);

  const emptyLine = {
    id: null,
    transactionItemId: null,
    transactionUom: '',
    unitPrice: 0,
    transactionQuantityIn: 0,
    transactionQuantityOut: 0,
    lotId: '',
    referenceIdMaster: '',
    referenceIdLine: ''
  };

  const formik = useFormik({
    initialValues: {
      code: '',
      transactionDate: new Date().toISOString().split('T')[0],
      description: '',
      branchId: '',
      transactionAmount: 0,
      referenceType: '',
      referenceCode: '',
      referenceId: '',
      supplierId: null as any,
      customerId: null as any,
      // personId: personId,
      personId: null,
      subInventoryId: null as any,
      inventoryId: '',
      inventoryTo: '',
      address: '',
      note: '',
      methodTransfer: 1,
      hasAssemblyItem: false, // ✅ جديد

      fileAttachment: [] as File[],
      //
      materialTransactionsLineList: [emptyLine]
    },
    enableReinitialize: true,
    validationSchema: AddIssueTransactionsSchema(t),
    onSubmit: values => {
      const Lines = values.materialTransactionsLineList?.filter(f => f.transactionQuantityIn !== 0);
      if (Lines.length === 0) {
        CustomAlert({ action: 'info', msg: 'لا يوجد أصناف' });
        formik.setSubmitting(false);
        return;
      }

      // debugger;
      dispatch(
        addIssueTransactions({
          code: values.code,
          transactionDate: values.transactionDate,
          description: values.description,
          methodTransfer: values.methodTransfer,
          branchId: values.branchId,
          transactionAmount: 0,
          referenceType: values.referenceType || values.code,
          referenceId: values.referenceId || null,
          supplierId: values.supplierId || null,
          customerId: values.customerId || null,
          personId: values.personId || null,
          inventoryId: values.inventoryId,
          inventoryTo: values.inventoryTo || null,
          address: values.address,
          note: values.note,
          transactionYear: 0,
          subInventoryId: values.subInventoryId,
          referenceCode: values.referenceCode,
          hasAssemblyItem: values.hasAssemblyItem, // هل يحتوي على صنف تجميعي
          // hasAssemblyItem: true, // هل يحتوي على صنف تجميعي
           fileAttachment: values.fileAttachment, // ✅ جديد
          materialTransactionsLineList: values.materialTransactionsLineList?.map((item: any) => ({
            transactionItemId: item.transactionItemId,
            transactionUom: item.transactionUom,
            unitPrice: item.unitPrice || 0,
            transactionQuantityIn: item.transactionQuantityIn,
            transactionQuantityOut: 0,
            lotId: item.lotId || null,
            inventoryId: null,
            referenceIdMaster: item.referenceIdMaster || null,
            referenceIdLine: item.referenceIdLine || null,
            transactionTypeId: null
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            Navigate(-1 as any, { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;

  const isLoading = useMemo(
    () => loading1 || loading2 || loading3 || loading4 || loading5 || loading6,
    [loading1, loading2, loading3, loading4, loading5, loading6]
  );

  const isError = useMemo(
    () => error1 || error2 || error3 || error4 || error5 || error6,
    [error1, error2, error3, error4, error5, error6]
  );

  // تحديد المخزن الفرعي الأول تلقائيًا عند تغيير المخزن الرئيسي أو عند تحميل البيانات
  useEffect(() => {
    if (values.inventoryId && TreeSubInventoryData?.length > 0) {
      const filteredSubInventories = TreeSubInventoryData.filter(f => f.parentId === values.inventoryId);

      if (!values.subInventoryId && filteredSubInventories.length > 0) {
        formik.setFieldValue('subInventoryId', filteredSubInventories[0].value);
      }
    }
  }, [values.inventoryId, TreeSubInventoryData]);

  const selectedOU = OperatingUnitOptions?.find((x: any) => x.value === formik.values.branchId);
  const selectedInv = InventoryOptions?.find((x: any) => x.value === formik.values.inventoryId);
  const selectedInvTo = InventoryOptions2?.find((x: any) => x.value === formik.values.inventoryTo);
  const selectedType = OptionsTransactionTypes?.find((x: any) => x.value === formik.values.code);

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          { name: t('Home'), link: ':moduleHome' },
          { name: t('InvIssue'), link: '' },
          { name: t('AddIssueDocument'), link: null }
        ]}
        PageName={t('AddIssueDocument')}
        subtitle={selectedInv?.label}
      />

      {/* ✅ نفس آلية Receive: لا تظهر الشاشة إلا بعد إغلاق مودال البداية */}
      {!showModal && (
        <Form onSubmit={formik.handleSubmit}>
          <Loading loading={isLoading} error={isError}>
            <Card>
              <CardBody>
                {/* ✅ ملخص الاختيارات من المودال */}
                <Card className='mb-3 border-0 bg-theme bg-opacity-10'>
                  <div className='p-3 d-flex flex-wrap gap-4 align-items-center justify-content-between'>
                    <div>
                      <div className='small text-muted'>{t('OperatingUnit')}</div>
                      <div className='fw-bold'>{selectedOU?.label ?? '-'}</div>
                    </div>

                    <div>
                      <div className='small text-muted'>{t('Inventory')}</div>
                      <div className='fw-bold'>{selectedInv?.label ?? '-'}</div>
                    </div>
                    {values.code === 'MOI' && (
                      <div>
                        <div className='small text-muted'>{t('الى مخـزن')}</div>
                        <div className='fw-bold'>{selectedInvTo?.label ?? '-'}</div>
                      </div>
                    )}

                    <div>
                      <div className='small text-muted'>{t('TransactionType')}</div>
                      <div className='fw-bold'>{selectedType?.label ?? '-'}</div>
                    </div>

                    <div>
                      <div className='small text-muted'>{t('Reference')}</div>
                      <div className='fw-bold'>{formik.values.referenceCode || formik.values.referenceId || '-'}</div>
                    </div>
                  </div>
                </Card>

                <div className='row '>
                  {/* التاريخ */}
                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Date')}</label>
                      <Form.Control
                        className='form-control text-center'
                        type='date'
                        name='transactionDate'
                        onChange={formikhandleChange}
                        value={values.transactionDate || ''}
                      />
                      <div className='text-danger small'>
                        {touched.transactionDate && (errors.transactionDate as any)}
                      </div>
                    </div>
                  </div>

                  {/* المخزن الفرعي */}
                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('SubInventory')}</label>
                      <TreeSelect
                        loading={loading3}
                        showSearch
                        className='w-100'
                        treeLine
                        placeholder={t('Choose')}
                        allowClear
                        treeDefaultExpandAll={false}
                        value={values.subInventoryId}
                        onChange={(option: any) => {
                          formik.setFieldValue('subInventoryId', option === null ? null : option);
                        }}
                        treeData={TreeSubInventoryData?.filter(f => f.parentId === values.inventoryId)}
                        treeNodeFilterProp='title'
                      />
                      <div className='text-danger small'>
                        {touched.subInventoryId && (errors.subInventoryId as any)}
                      </div>
                    </div>
                  </div>

                  {/* المورد / العميل حسب نوع الحركة */}
                  {['SPR', ''].includes(values.code) && (
                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Supplier')}</label>
                        <TreeSelect
                          loading={loading5}
                          disabled
                          showSearch
                          className='w-100'
                          treeLine
                          placeholder={t('Choose')}
                          allowClear
                          treeDefaultExpandAll={false}
                          value={values.supplierId}
                          onChange={(option: any) => {
                            formik.setFieldValue('supplierId', option === null ? null : option);
                          }}
                          treeData={treeSuppliersData}
                          treeNodeFilterProp='title'
                        />
                        <div className='text-danger small'>{touched.supplierId && (errors.supplierId as any)}</div>
                      </div>
                    </div>
                  )}

                  {['INV', 'SOI'].includes(values.code) && (
                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Customer')}</label>
                        <TreeSelect
                          disabled
                          loading={loading4}
                          showSearch
                          className='w-100'
                          treeLine
                          allowClear
                          treeDefaultExpandAll={false}
                          value={values.customerId}
                          onChange={(option: any) => {
                            formik.setFieldValue('customerId', option === null ? null : option);
                          }}
                          treeData={treeCustomerData}
                          treeNodeFilterProp='title'
                          placeholder={t('Choose')}
                        />
                        <div className='text-danger small'>{touched.customerId && (errors.customerId as any)}</div>
                      </div>
                    </div>
                  )}

                  {/* الوصف/ملاحظة */}
                  <div className='col-lg-6'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Note')}</label>
                      <Form.Control
                        autoComplete='off'
                        className='form-control'
                        as='textarea'
                        rows={1}
                        name='description'
                        onChange={formik.handleChange}
                        value={values.description}
                      />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Loading>

          <Card className='pt-1 mt-2 shadow-sm '>
            {values.inventoryId && <IssueLines formik={formik} handleSubmit={formik.handleSubmit} />}
          </Card>

          <Card className=' mt-3'>
            <CardHeader className=''>
              <Form.Label className='m-0'>{t('Attachments')}</Form.Label>
            </CardHeader>
            <CardBody>
              <div className='form-group mb-3'>
                <FileUpload
                  attachments={formik.values.fileAttachment}
                  setAttachments={(updater: any) => {
                    const next = typeof updater === 'function' ? updater(formik.values.fileAttachment) : updater;

                    formik.setFieldValue('fileAttachment', next);
                    // اختياري لو عندك فاليديشن على المرفقات
                    // formik.setFieldTouched('fileAttachment', true, true);
                  }}
                  multiple={false}
                />
              </div>
            </CardBody>
          </Card>

          <Card className='p-2 mt-2'>
            <div className='text-end  '>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme rounded'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                )}
                {t('Add')}
              </button>
              <button type='button' className='btn btn-lg me-1 btn-default   rounded' onClick={() => Navigate(-1)}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Card>
        </Form>
      )}

      {/* ✅ مودال البداية (نفس Receive) */}
      <TransactionStartModal
        show={showModal}
        onCancel={() => Navigate('/INV/Transactions/InvIssue')}
        onConfirm={({ branchId, inventoryId, code, referenceId, referenceCode }) => {
          formik.setFieldValue('branchId', branchId);
          formik.setFieldValue('inventoryId', inventoryId);
          formik.setFieldValue('code', code);

          // للتماشي مع الـ API/التحقق
          formik.setFieldValue('referenceType', code);

          formik.setFieldValue('referenceId', referenceId);
          formik.setFieldValue('referenceCode', referenceCode);

          formik.setFieldValue('hasAssemblyItem', false); // ✅
          // صفوف الحركة
          formik.setFieldValue('materialTransactionsLineList', [emptyLine]);

          setShowModal(false);
        }}
        OperatingUnitOptions={OperatingUnitOptions}
        InventoryOptions={InventoryOptions}
        OptionsTransactionTypes={OptionsTransactionTypes}
        loading={loading1 || loading2 || loading6}
        error={error1 || error2 || error6}
        requireReference={true}
        //
        headerTitle={i18n.language === 'ar' ? ' إذن صرف مخزني' : ' Inventory Issue'}
        headerSubtitle={
          i18n.language === 'ar'
            ? 'اختر نوع الصرف ثم الوحدة والمخزن والمرجع'
            : 'Choose issue type, OU, inventory and reference'
        }
        headerIconClassName='fas fa-arrow-up'
      />
    </>
  );
};

export default Add;
